import { Button } from '@skytech/ui/Button'
import { Image } from '@skytech/ui/Image'
import CheckboxBlankCircleOutlineIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'
import InfoCircleOutlineIcon from 'mdi-react/InfoCircleOutlineIcon'
import { useDispatch, useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import {
  deselectProduct,
  getIsProductSelected,
  getNonShippingInventory,
  selectProduct,
} from '@/ducks/hardwareReducer'
import { openModal } from '@/ducks/modalReducer'

import OldOrderLines from './OldOrderLines'

import './inventory.scss'

const Inventory = () => {
  const inventory = useSelector(getNonShippingInventory)

  return (
    <div className="inventory">
      <OldOrderLines />
      <div className="inventory__instructions">
        <h3>Slik fungerer støtte av utstyr</h3>
        <p>
          KPMG eier utstyret, slik at det ikke blir en skattepliktig fordel. Hadde hver enkelt kjøpt
          utstyret selv og fått dette refundert som utlegg, ville det vært skattepliktig.
        </p>

        <p>
          Noe av utstyret vil bli levert på din dør og annet rett til post i butikk. Les detaljer
          vedr. levering i ordrebekreftelsen du får etter fullført bestilling. Husk det er noe
          leveringstid på flere av disse produktene.
        </p>

        <p>
          Utstyret bestilt via Skytech Control blir ditt når arbeidsforholdet avsluttes. Utstyret er
          ment å vare i 48 måneder. Så dersom du har hatt utstyret i 24 mnd og du har fått utstyr
          til kr 5000 inkl mva, blir du trukket kr 2500,- på siste lønnsutbetaling.
        </p>
      </div>

      <div className="inventory__products">
        {/* @ts-ignore */}
        {inventory.map(product => (
          <Product key={product.id} {...product} />
        ))}
      </div>
    </div>
  )
}

export default Inventory
// @ts-ignore
const Product = ({ id, name, img_url, description, buying_price }) => {
  const dispatch = useDispatch()

  const isProductSelected = useSelector(state => getIsProductSelected(state, id))
  const onClick = () => dispatch(isProductSelected ? deselectProduct(id) : selectProduct(id))
  // @ts-ignore
  const showInfo = e => {
    e.stopPropagation()
    dispatch(
      // @ts-ignore
      openModal(
        <div>
          <h4>{name}</h4>
          <p>{description}</p>
        </div>
      )
    )
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={`inventory__products__product ${isProductSelected ? 'selected' : 'not-selected'}`}
      onClick={onClick}
    >
      <div className="name">{name}</div>

      <div className="img">
        <Image src={img_url} alt="product" />
      </div>

      <div className="price">
        <FormattedNumberWithCurrency amount={buying_price} />
      </div>

      <div className="checkmark">
        {isProductSelected ? (
          <CheckboxMarkedCircleOutlineIcon />
        ) : (
          <CheckboxBlankCircleOutlineIcon />
        )}
      </div>

      {description && (
        <div className="info">
          <Button
            variant="tertiary"
            onClick={showInfo}
            Icon={<InfoCircleOutlineIcon className="mr-0" />}
          />
        </div>
      )}
    </div>
  )
}
